import BadgeLink from 'components/BadgeLink'
import Image from 'components/Image'
import Link from 'components/Link'
import PropTypes from 'prop-types'
import React from 'react'
import theme from 'styles/theme'

const PostCard = ({ title, slug, category, excerpt, image, cardStyles }) => (
  <div
    className='PostCard'
    css={{
      ...cardStyles,
    }}
  >
    <Link
      to={slug.current}
      css={{
        display: 'block',
        color: theme.colors.spinachDark,
        transition: theme.globalTransition,
        paddingBottom: '1rem',
        ':hover': {
          color: theme.colors.spinach,
          img: {
            boxShadow: '12px 12px 0 0' + theme.colors.spinachLight,
          },
        },
        [theme.smallOnly]: {
          display: 'flex',
          justifyContent: 'space-between',
          '.image-wrapper': {
            width: '120px',
            height: '120px',
            paddingBottom: 'unset!important',
          },
        },
      }}
    >
      <div
        className='image-wrapper'
        css={{
          position: 'relative',
          paddingBottom: '100%',
          marginBottom: '1rem',
        }}
      >
        <Image
          {...image}
          width={800}
          alt={title}
          css={{
            transition: theme.fastTransition,
            position: 'absolute',
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      </div>
      <div
        css={{
          [theme.smallOnly]: {
            width: 'calc(100% - 140px)',
          },
        }}
      >
        {category && category.map(cat => <BadgeLink small>{cat.title}</BadgeLink>)}
        <h3
          css={{
            [theme.smallOnly]: {
              fontSize: '1.3rem',
            },
            ...theme.h4,
            fontWeight: 'bold',
            margin: '0.5rem 0 1rem',
            maxWidth: '18em',
          }}
        >
          {title}
        </h3>
        <p
          css={{
            ...theme.paragraph,
            maxWidth: '32em',
          }}
        >
          {excerpt}
        </p>
      </div>
    </Link>
  </div>
)

PostCard.propTypes = {
  title: PropTypes.string.isRequired,
  slug: PropTypes.object.isRequired,
  category: PropTypes.object.isRequired,
  excerpt: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
  cardStyles: PropTypes.object,
}

export default PostCard
